<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .btn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
.dialog-footer{margin-top: 50px;}
// /deep/ .el-dialog__body{height: 165px;}
/deep/ .el-checkbox__inner{margin-left: -140px;}
/deep/ .el-checkbox__label{margin-left: -5px;}
.btn {margin: 0px auto;height: 60px;z-index: 19999;}
.btn .el-button {height: 40px;margin: 10px auto;}
.btn {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
.el-tablebox {margin-bottom: 60px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center',}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="name" label="管理员"></el-table-column>
          <el-table-column prop="id" label="操作" width="300">
            <template slot-scope="scope">
               <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
               <el-button type="danger" @click="deletefn(11, 117,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn">
        <el-button type="success" @click="addfn()">添加</el-button>
      </div>
    </div>
    <div>
      <el-dialog title="数据添加" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="管理员名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
                <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="userMessageAdd">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="数据修改" :visible.sync="dialogFormVisibles">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="管理员名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
                <el-input v-model="form.phone" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="updata">修 改</el-button>
            <el-button @click="revert">返 回</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import filters from '../method/filter'
import method from '../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, method],
  data()
  {
    let validatePhone = (rule, value, callback) =>
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的手机号'))
        else
          callback()
      }
      else
        callback(new Error('请输入手机号'))
    }
    return {
      value: [],
      form:
      {
        name: '',
        phone: ''
      },
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibles: false,
      formLabelWidth: '200px',
      dataRole: [],
      dataUser: [],
      dataid: '',
      roleArr: [],
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }]
      }
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  filters:
  {
    gender: function(num)
    {
      switch (num)
      {
      case 0: return '男'
      case 1: return '女'
      }
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    userMessageAdd()
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.tableData.length < 5)
      {
        this.$refs.form.validate(valid =>
        {
          if (valid)
          {
            let obj = {
              cmd: 'add',
              _major: 11,
              _minor: 117,
              retAtt: 1,
              name: this.form.name,
              phone: this.form.phone
            }
            window.post.getPost(obj).then((ret) =>
            {
              if (ret.ret === 1)
              {
                this.$message({message: '添加失败', type: 'error', customClass: 'mzindex'})
                this.getList()
                this.form.name = ''
                this.form.phone = ''
                this.dialogFormVisible = false
              }
              else
              {
                this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
                this.getList()
                this.form.name = ''
                this.form.phone = ''
                this.dialogFormVisible = false
              }
            })
          }
          else if (!regtel.test(this.form.phone))
            this.$message({message: '请填写正确的手机号', type: 'error', customClass: 'mzindex'})
        })
      }
      else
        this.$message({message: '数据添加最多不能超过5条', type: 'error', customClass: 'mzindex'})
    },
    cancel()
    {
      this.getList()
      this.form.name = ''
      this.form.phone = ''
      this.dialogFormVisible = false
    },
    //获取数据
    getList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 117, _exp: 'id>0',  orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        ret.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            name: item.name,
            phone: item.phone
          })
        })
      })
    },
    //点击修改
    updatafn(row)
    {
      this.dataid = row.id
      this.dialogFormVisibles = true
      let paras = {cmd: 'query', _major: 11, _minor: 117, _exp: `id = '${row.id}'`,  orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.form.name = ret[0].name
        this.form.phone = ret[0].phone
      })
    },
    // 实现修改功能
    updata()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 117,
        retAtt: 1,
        id: this.dataid,
        name: this.form.name,
        phone: this.form.phone
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
        {
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          this.getList()
          this.form.name = ''
          this.form.phone = ''
          this.dialogFormVisibles = false
        }
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.getList()
          this.form.name = ''
          this.form.phone = ''
          this.dialogFormVisibles = false
        }
      })
    },
    // 返回
    revert()
    {
      this.getList()
      this.form.name = ''
      this.form.phone = ''
      this.dialogFormVisibles = false
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.dialogFormVisible = true
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/UserGetMessage.vue